function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M240 480C107.453 480 0 372.547 0 240C0 107.453 107.453 0 240 0C372.547 0 480 107.453 480 240C479.852 372.484 372.484 479.852 240 480ZM240 16C116.289 16 16 116.289 16 240C16 363.711 116.289 464 240 464C363.711 464 464 363.711 464 240C463.859 116.348 363.652 16.1406 240 16Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M376 232H248V104C248 99.582 244.418 96 240 96C235.582 96 232 99.582 232 104V232H104C99.582 232 96 235.582 96 240C96 244.418 99.582 248 104 248H232V376C232 380.418 235.582 384 240 384C244.418 384 248 380.418 248 376V248H376C380.418 248 384 244.418 384 240C384 235.582 380.418 232 376 232Z",
  fill: "currentColor"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.6312db4e.svg";
export { ForwardRef as ReactComponent };